import { Component } from '@angular/core';
import { AbstractPlugin } from '../../abstract-plugin.component';

@Component({
    selector: 'plugin-empty-template',
    templateUrl: 'empty.component.html',
    styleUrls: ['empty.component.scss']
})
export class PluginEmptyTemplate extends AbstractPlugin {
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/templates/empty/empty.component.ts